<script lang="ts">
	import { getSecondarySourceSubtitle } from '#lib/util/secondary-source.ts';
	import { getFormattedDate } from '#lib/util/time';
	import type { DocumentOverview } from '#src/types/documents.ts';
	import {
		isSecondarySource,
		resolveSecondarySource,
		type CitedSource,
		type SecondarySource
	} from '#src/types/sources.ts';
	import { t } from './i18n/tranlsator.svelte';

	interface Props {
		doc: DocumentOverview | SecondarySource | CitedSource;
	}
	let { doc }: Props = $props();

	function getSubtitle(type: string) {
		const key = `docType.${type}` as Parameters<typeof t>[0];
		const translated = t(key);
		return translated === key ? type : translated;
	}

	const secondarySource = $derived.by<SecondarySource | undefined>(() => {
		if ('occurrences' in doc) {
			return resolveSecondarySource(doc);
		}
		return isSecondarySource(doc) ? doc : undefined;
	});

	const published_date = $derived(
		secondarySource == null
			? (doc as DocumentOverview).date ||
					(doc as DocumentOverview).res_date ||
					(doc as DocumentOverview).meta?.speech_date
			: undefined
	);
</script>

<div class="info">
	{#if secondarySource}
		<span class="title">{secondarySource.title}</span>
		<span class="subtitle">{getSecondarySourceSubtitle(secondarySource)}</span>
	{:else}
		{@const d = doc as DocumentOverview}
		<span class="title">
			{#if d.type === 'speech'}Rede von {d.meta?.speaker}
			{:else if d.type === 'eu_com_proposal'}Commission Proposal {d.meta?.com_id}
			{:else if d.type === 'cla_paragraph'}{d.meta?.section_id} {d.res_name}
			{:else}
				{d.res_name}
			{/if}
		</span>
		{#if d.type === 'cla_paragraph' || d.type === 'cla_annex'}
			<span class="subtitle">{d.res_name}</span>
		{:else}
			<span class="subtitle">
				{published_date ? getFormattedDate(published_date) + ' | ' : ''}{getSubtitle(
					d.type
				)}{d.type === 'kleine_anfrage' ? ` | ${d.meta.urheber}` : ''}
			</span>
		{/if}
	{/if}
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;
	.info {
		flex: 1 1 auto;
		@include lib.flex-column();
		@include lib.flex-align(center, stretch);
		overflow: hidden;
		text-align: left;
		gap: 0.25rem;
		.title {
			@include lib.ellipsis();
		}
		.subtitle {
			@include lib.ellipsis();
			font-size: 0.75rem;
			color: var(--text-secondary);
		}
	}
</style>
